import  {CustomerLedgerEntry, type CustomerLedgerEntryData} from "@/types/erp/customerLedgerEntry";

export class SeaInvoice {
    public id: number | null;
    public organisation_external_reference: string;
    public series: string;
    public invoice_number: string;
    public invoice_date: string;
    public invoice_currency: string;
    public combined_invoice_number: string;
    public customerLedgerEntry: CustomerLedgerEntry | null;


    constructor(data: SeaInvoiceData | void) {
        if (data === undefined) {
            this.id = null;
            this.organisation_external_reference = '';
            this.series = "";
            this.invoice_number = "";
            this.invoice_date = "";
            this.invoice_currency = "";
            this.combined_invoice_number = "";
            this.customerLedgerEntry = null;
        } else {
            this.id = data.id;
            this.organisation_external_reference = data.organisation_external_reference;
            this.series = data.series;
            this.invoice_number = data.invoice_number;
            this.invoice_date = data.invoice_date;
            this.invoice_currency = data.invoice_currency;
            this.combined_invoice_number = data.combined_invoice_number;
            this.customerLedgerEntry = null;
            if (data.customerLedgerEntry !== undefined && data.customerLedgerEntry !== null) {
                this.customerLedgerEntry = new CustomerLedgerEntry(data.customerLedgerEntry)
            }

        }
    }

}

export type SeaInvoiceData = {
    id: number | null;
    organisation_external_reference: string;
    series: string;
    invoice_number: string;
    invoice_date: string;
    invoice_currency: string;
    combined_invoice_number: string;
    customerLedgerEntry: CustomerLedgerEntryData | null;
}